<template>
  <div class="produceInformationPackage table-responsive col-12">
    <li
      style="
        display: block;
        color: #000000;
        font-family: dfyuanstd-w5, dfyuanstd-w3;
        font-size: 1rem;
      "
    >
      產品資訊
    </li>
    <b-table
      :items="produceInformationPackageItem"
      :fields="produceInformationPackageFields"
      class="text-center produceInformationPackage-table-detail"
    >
    </b-table>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "produceInformationPackage",
  data() {
    return {};
  },
  computed: {
    ...mapGetters({
      produceInformationPackageFields:
        "produceInformationPackage/get_produceInformationPackageFields",
      produceInformationPackageItem:
        "produceInformationPackage/get_produceInformationPackageItem",
    }),
  },
};
</script>

<style lang="scss">
.produceInformationPackage-table-detail thead th {
  border-top: 1px solid;
}
.produceInformationPackage-table-detail th,
.produceInformationPackage-table-detail td {
  font-size: 1rem;
  min-width: 65px;
  padding: 0.1rem;
  border-color: #999999 !important;
  border-bottom: 1px solid #999999 !important;
  border-right: 1px solid;
  font-weight: normal;
  background-color: #ffffff;
  vertical-align: middle !important;
}
.produceInformationPackage-table-detail th:first-child,
.produceInformationPackage-table-detail td:first-child {
  border-left: 1px solid;
}
.produceInformationPackage-table-detail {
  margin-bottom: 0px;
}
.produceInformationPackage-table-detail thead th {
  color: #000000 !important;
  background-color: #cccccc !important;
}

.produceInformationPackage-table-detail tr th:nth-child(2),
.produceInformationPackage-table-detail tr td:nth-child(2) {
  width: 150px;
  min-width: 150px;
}

.produceInformationPackage-table-detail tr th:nth-child(3),
.produceInformationPackage-table-detail tr td:nth-child(3) {
  width: 110px;
  min-width: 110px;
}
</style>



// WEBPACK FOOTER //
// src/components/produceInformationPackage.vue